import React, { ReactNode, useContext, useMemo, useState } from 'react';

interface MenuProviderProps {
  isMenuOpen: boolean;
  toggleMenu: () => void;
}

const defaultValue: MenuProviderProps = {
  isMenuOpen: false,
  toggleMenu: () => undefined,
};

const MenuContext = React.createContext<MenuProviderProps>(defaultValue);

function MenuContextProvider({ children }: { children: ReactNode }) {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const memoizedValue: MenuProviderProps = useMemo(
    () => ({
      isMenuOpen,
      toggleMenu,
    }),
    [isMenuOpen],
  );

  return <MenuContext.Provider value={memoizedValue}>{children}</MenuContext.Provider>;
}

export default MenuContextProvider;
export const useMenuContextProvider = (): MenuProviderProps => useContext(MenuContext);
